import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExamcompassClient } from '../Api/api';
import { DecryptedAuthToken, encrypt } from '../utils/encryption';

const AuthorisationRoute: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const encodedData = params.get('code');
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  console.log(encodedData);
  const dashboard_url = process.env.REACT_APP_DASHBOARD_URL;

  useEffect(() => {
    const sendCallbackCode = async () => {
      try {
        if (encodedData) {
          const { data } = await ExamcompassClient.post(`google/callback/`, {
            id_token: encodedData,
          });

          if (data) {
            const payload: DecryptedAuthToken = {
              authToken: data.token,
              rememberMe: false,
            };
            const token = encrypt(payload, 'salt');
            const encodedParam = btoa(token);
            window.location.href = `${dashboard_url}/auth/${encodedParam}`;
            return;
          }
          setError('Invalid or missing data');
        } else {
          setError('Invalid or missing token');
          navigate('/login'); // Redirect immediately if data is invalid
          return;
        }
      } catch (error) {
        setError('Something went wrong!. Please try again.');
        navigate('/login'); // Redirect immediately if data is invalid
      }
    };
    sendCallbackCode();
  }, [navigate, encodedData, dashboard_url]);

  return (
    <div className='container'>
      {error && <span className='error_text'>{error}</span>}
      {!error && <p>Redirecting....</p>}
    </div>
  );
};

export default AuthorisationRoute;
